import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const ThailandPage = () => {
  return <DestinationTemplate destinationId="thailand" />;
};

export default ThailandPage;
